"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIPE_CHECKIN_DATA = exports.CHECKINPASS_SUCCESS = exports.CHECKINPASS_REQUEST = exports.CHECKINPASS_FAIL = void 0;
var CHECKINPASS_REQUEST = exports.CHECKINPASS_REQUEST = '@CheckinPass/CHECKINPASS_REQUEST';
var CHECKINPASS_SUCCESS = exports.CHECKINPASS_SUCCESS = '@CheckinPass/CHECKINPASS_SUCCESS';
var CHECKINPASS_FAIL = exports.CHECKINPASS_FAIL = '@CheckinPass/CHECKINPASS_FAIL';
var WIPE_CHECKIN_DATA = exports.WIPE_CHECKIN_DATA = '@CheckinPass/WIPE_CHECKIN_DATA';